module.exports = __webpack_public_path__ + "img/404.ba353011.svg";